import { useQuery } from "react-query";
import { loggedInApiCall } from "src/api/axiosClient/userApi";
import { zodParseWithLog } from "src/api/apiErrorLogs";
import { PostSchema } from "./postSchema";
import { ScoreQuery } from "src/context/EntityBasedScore/useEntityBasedScoreParams";

type Options = {
    companyId: number | undefined;
    campaignId: number | undefined;
    scoreQuery?: Omit<ScoreQuery, "campaign">;
    statistics?: boolean;
};

export const getCompanyPostApiKey = "getCompanyPost" as const;

export const useGetCompanyPost = (options: Options) => {
    const { companyId, campaignId, scoreQuery, statistics = false } = options;
    const { dimensions = ["main"], variations = {} } = scoreQuery || {};

    const query = useQuery({
        queryKey: [getCompanyPostApiKey, companyId, campaignId, dimensions, variations, statistics],
        enabled: companyId !== undefined && campaignId !== undefined,
        queryFn: async () => {
            const url = `/api/companies/${companyId}/ssq_post`;

            return await loggedInApiCall.get(url.toString(), {
                headers: {
                    Accept: "application/json",
                },
                params: {
                    campaign: campaignId,
                    dimensions,
                    variations,
                    statistics,
                },
            });
        },
        select: (response) => {
            if (!response) {
                return;
            }

            const post = response.data;
            const data = zodParseWithLog(post, PostSchema, getCompanyPostApiKey);
            return data;
        },
    });

    return {
        post: query.data,
        ...query,
    };
};
